/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { importAllImages } from '../../../../utils/helpers';
import Button from '../../../../components/button';
import cog from '../../../../icons/settings.svg';
import styles from '../steps.module.scss';

class Step0 extends Component {
  constructor(props) {
    super(props);

    this.images = importAllImages(
      require.context(
        '../../../../icons',
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    this.state = {
      stage: 1
    };
  }

  componentDidUpdate() {
    const { check } = this.state;
    const { info } = this.props;
    if (check !== info?.is_anonymous) {
      this.setState({ check: info.is_anonymous });
    }
  }

  render() {
    const { goToNext, onUserCheck, info, enableBadge, anonymousSetting } = this.props;
    const { stage } = this.state;
    return (
      <>
        {stage === 1 && (
          <div className={`${styles.inspection_list} ${styles.step0}`}>
            <img
              className={styles.title_img}
              src={cog}
              alt="inspection_list_icon"
            />
            <h3 className={styles.inspection_list_title}>
              <FormattedMessage
                id="sms.fullForm"
                defaultMessage="Safety Management System"
              />
            </h3>
            <div style={{ textAlign: 'left' }}>
              {anonymousSetting
              && <div className={styles.check}>
                  <input
                    name="question"
                    id="is_anonymous"
                    type="radio"
                    onChange={() => onUserCheck('hazardInfo', !info.is_anonymous, 'is_anonymous')
                          }
                    value
                    defaultChecked={info.is_anonymous}
                  />
                  &nbsp;&nbsp;
                  <FormattedMessage id="sms.new.anonymous_check" defaultMessage="Anonymous" />
                 </div>
              }
              {enableBadge && (
              <div className={styles.check}>
                <input
                  name="question"
                  type="radio"
                  id="badge_info"
                  onChange={() => onUserCheck('hazardInfo', !info.badge_info, 'badge_info')
                        }
                  value
                  defaultChecked={info.badge_info}
                />
                &nbsp;&nbsp;
                <FormattedMessage id="sms.new.badgeNum" defaultMessage="Badge Number" />
              </div>
              )}
              {(anonymousSetting || enableBadge) && (
              <div className={styles.check}>
                <input
                  name="question"
                  type="radio"
                  id="contact_info"
                  onChange={() => onUserCheck('hazardInfo', !info.contact_info, 'contact_info')
                        }
                  value
                  defaultChecked={info.contact_info}
                />
                &nbsp;&nbsp;
                <FormattedMessage id="sms.new.contactInfo" defaultMessage="Contact Information" />
              </div>
              )}
            </div>
            <div className={styles.separator} />
            <Button
              onClick={goToNext}
              translationID="hazard.new.startReport"
              defaultText="Start Report"
              action="secondary"
            />
          </div>
        )}
      </>
    );
  }
}

Step0.propTypes = {
  goToNext: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  onUserCheck: PropTypes.func.isRequired,
  check: PropTypes.shape({}).isRequired
};

export default withRouter(Step0);
